export enum ServiceLanguages {
  English = 'en',
  Italian = 'it',
  Spanish = 'es'
}
